<template>
  <div>
    <b-button
      v-if="videoForCurrentPage"
      variant="transparent"
      class="side-video-instructions reset-button"
      @click="showVideoInstructions = !showVideoInstructions"
    >
      <div class="video-wrapper">
        <div class="helper-text ml-3">
          {{ $t('login.login_activate.help') }}
        </div>

        <div>
          <sdui-icon class="icon icon-file_movie" />
        </div>
      </div>

      <img src="/img/miscellaneous/ui/video-notch.svg"
           alt=""
           class="svg-color"
           loading="lazy"
      />
    </b-button>
    <sdui-video-modal
      v-if="videoSource"
      with-transition
      :video-source="videoSource"
      :show-video="showVideoInstructions"
      :iframe-title="videoTitle"
      @close="showVideoInstructions = false"
    />
  </div>
</template>

<script>
import brandingMixin from 'src/mixins/branding/brandingMixin.js'
import SduiVideoModal from 'src/components/miscellaneous/ui/modals/SduiVideoModal.vue'

export default {
  name: 'RouterSideVideo',
  components: { SduiVideoModal },
  mixins: [brandingMixin],
  data: () => ({
    showVideoInstructions: false,
  }),

  computed: {
    videoForCurrentPage() {
      if (!this.brandingConfig.onboarding.help_videos) return
      return this.$route.meta.video
    },

    videoSource() {
      if (this.dynamicSource) {
        return this.dynamicSource
      }

      const url = this.videoForCurrentPage?.url

      return url && this.$t(url)
    },

    blockForceOpen() {
      return this.$store.state.video.blockForceOpen
    },

    dynamicSource() {
      return this.$store.state.video.source
    },

    videoTitle() {
      return this.videoForCurrentPage ? this.$t(`${this.videoForCurrentPage.url}_title`) : ''
    },
  },

  watch: {
    '$route.path': {
      async handler() {
        await this.$nextTick()
        if (!this.videoForCurrentPage) return
        this.showVideoInstructions = !!this.videoForCurrentPage?.forceOpen && !this.blockForceOpen
      },
    },

    async blockForceOpen(val) {
      if (!val) return
      await this.$nextTick()
      this.showVideoInstructions = false
      this.$store.dispatch('video/blockForceOpen', false)
    },
  },
}
</script>

<style scoped lang="scss">
.svg-color {
  filter: var(--primary-svg-filter);
}

.side-video-instructions {
  z-index: 1;
  top: 40%;
  right: 0;
  width: 100px;
  height: 200px;
  cursor: pointer;
  position: fixed;
  text-align: center;
  margin-top: -2px;
  transition: 0.2s ease-in-out;

  img {
    position: fixed;
    height: 200px;
    z-index: -1;
    top: 40%;
    right: -5px;
    transition: 0.2s ease-in-out;
  }

  .video-wrapper {
    border-radius: 16px;
    height: 200px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 65px !important;
    width: 100%;
    margin-top: 17px;
    color: $color-white;

    .helper-text {
      width: 100%;
      padding-bottom: 32px;
      margin-bottom: 32px;
      font-weight: $font-weight-light;
    }

    .icon-file_movie {
      font-size: pxtorem(38);
      position: relative;
      right: 2px;
    }
  }

  &:hover {
    transition: 0.2s ease-in-out;
    right: 5px;

    img {
      transition: 0.2s ease-in-out;
      right: 0;
    }
  }
}
</style>
